import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const deleteAddressMutationAtom = createMutationAtomFactory(
  'crm.addressDelete',
  ({ id }: { id: string }) => ({
    crmAccountAddressDelete: {
      __args: {
        id,
      },
    },
  }),
);
